module.exports = __webpack_public_path__ + "wireframe2.png?43b93634ad4e087c15ac971741a7b50a";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/wireframe2.png
// module id = 236
// module chunks = 0